import axios from "axios";
import "./SantanderFilter";

const systemUnavailableMessage = "Sistema indisponível, tente novamente mais tarde.";

const SantanderPropostaMixing = {
    data() {
        return {
            smp_optionsIssuingBodyDocument: [{ "code": "CBME", "label": "CORPO DE BOMBEIROS MILITAR DO EST. RJ (CBME)" },
                { "code": "CBMER", "label": "CONSELHO BOMBEIROS MILITARES ESTADO RJ (CBMER)" },
                { "code": "CIMCR", "label": "CGPMAF (CIMCR)" },
                { "code": "COREN", "label": "CONSELHO REGIONAL DE ENFERMAGEM (COREN)" },
                { "code": "CRA", "label": "CONSELHO REGIONAL DEADMINISTRACAO (CRA)" },
                { "code": "CRAS", "label": "CONSELHO REGIONAL DE ASSISTENTES SOCIAIS (CRAS)" },
                { "code": "CRB", "label": "CONSELHO REGIONAL DE BIBLIOTECONOMIA (CRB)" },
                { "code": "CRC", "label": "CONSELHO REGIONAL DOS CONTABILISTAS (CRC)" },
                { "code": "CRE", "label": "CONSELHO REGIONAL DOS ECONOMISTAS (CRE)" },
                { "code": "CREA", "label": "CONSELHO REGIONAL DE ENGENHARIA (CREA)" },
                { "code": "CRECI", "label": "CONSELHO REGIONAL CORRETORES DEIMOVEIS (CRECI)" },
                { "code": "CREF", "label": "CONSELHO REGIONAL DE EDUCAçãO FíSICA (CREF)" },
                { "code": "CREFI", "label": "CONSELHO REGIONAL DE FISIOTERAPIA (CREFI)" },
                { "code": "CREP", "label": "CONS REG DOS ECONOMISTASPROFISSIONAIS (CREP)" },
                { "code": "CRF", "label": "CONSELHO REGIONAL DE FARMACIA (CRF)" },
                { "code": "CRM", "label": "CONSELHO REGIONAL DE MEDICINA (CRM)" },
                { "code": "CRN", "label": "CONSELHO REGIONAL DENUTRICAO (CRN)" },
                { "code": "CRO", "label": "CONSELHO REGIONAL DEODONTOLOGIA (CRO)" },
                { "code": "CRP", "label": "CONSELHO REGIONAL DE PSICOLOGIA (CRP)" },
                { "code": "CRPRE", "label": "CONSELHO REGIONAL PROF RELACOESPUBLICAS (CRPRE)" },
                { "code": "CRQ", "label": "CONSELHO REGIONAL DE QUIMICA (CRQ)" },
                { "code": "CRRC", "label": "CONSELHO REGIONAL REPRESENT. COMERCIAIS (CRRC)" },
                { "code": "CRTA", "label": "CONSELHO FEDERAL DE TEC DEADMINISTRACAO (CRTA)" },
                { "code": "CRV", "label": "CONSELHO REGIONAL MEDICINA VETERINARIA (CRV)" },
                { "code": "DEPAD", "label": "DIVISAO ESTRANGEIROS PASSAPORTES (DEPAD)" },
                { "code": "DETRA", "label": "DEPARTAMENTO ESTADUAL DE TRâNSITO (DETRA)" },
                { "code": "DIC", "label": "DIRETORIA DE IDENTIFICACAO CIVIL (DIC)" },
                { "code": "DNPSC", "label": "DEPART NACIONAL DE SEGUR PRIV ECAP (DNPSC)" },
                { "code": "DOPS", "label": "DEPART ORDEM POLITICA SOCIAL (DOPS)" },
                { "code": "DPF", "label": "POLICIA FEDERAL (DPF)" },
                { "code": "DPMAF", "label": "DEP DE POLIC MARITIMA AREA DE FRONTEIRA (DPMAF)" },
                { "code": "DPMAT", "label": "DEP DE POLIC MARITIMA AREA DE FRONTEIRA EST (DPMAT)" },
                { "code": "ESTR", "label": "DOCUMENTOS ESTRANGEIROS (ESTR)" },
                { "code": "I CLA", "label": "CARTEIRA DE IDENTIDADECLASSISTA (I CLA)" },
                { "code": "IFP", "label": "INSTITUTO FELIX PACHECO (IFP)" },
                { "code": "IPF", "label": "INSTITUTO PEREIRA FAUSTINO (IPF)" },
                { "code": "MAE", "label": "MINISTERIO DA AERONAUTICA (MAE)" },
                { "code": "MAER", "label": "MINISTéRIO DA AERONáUTICA - RJ (MAER)" },
                { "code": "MB", "label": "MINISTERIO MARINHA DO BRASIL (MB)" },
                { "code": "MD", "label": "MINISTERIO DA DEFESA (MD)" },
                { "code": "MEX", "label": "MINISTERIO DOEXERCITO (MEX)" },
                { "code": "MJF", "label": "MINISTéRIO DA JUSTIçA FEDERATIVA - RJ (MJF)" },
                { "code": "MM", "label": "MINISTERIO DA MARINHA (MM)" },
                { "code": "MRE", "label": "MINISTERIO DAS RELACOES EXTERIORES (MRE)" },
                { "code": "MRECC", "label": "MINS DAS REL EXTERIORES CORPOCONSULAR (MRECC)" },
                { "code": "MTPS", "label": "MINIST DO TRABALHO E PREVIDENCIA SOCIAL (MTPS)" },
                { "code": "OAB", "label": "ORDEM DOS ADVOGADOS DO BRASIL (OAB)" },
                { "code": "OMB", "label": "ORDEM DOS MUSICOS DO BRASIL (OMB)" },
                { "code": "PGJ", "label": "PROCURADORIA GERAL DAJUSTICA (PGJ)" },
                { "code": "PM", "label": "POLICIA MILITAR (PM)" },
                { "code": "PMERJ", "label": "POLICIA MILITAR DO ESTADO DO RJ (PMERJ)" },
                { "code": "SDS", "label": "SECRETARIA DE DEFESA SOCIAL (SDS)" },
                { "code": "SEPC", "label": "SECRETARIA DE SEGURANCA PUBLICA (SEPC)" },
                { "code": "SIM", "label": "SERVICO DE IDENTIFICACAO DA MARINHA (SIM)" },
                { "code": "SPTC", "label": "SUPERINT POLíCIA TéCNICO-CIENTíFICA SP (SPTC)" },
                { "code": "SRF", "label": "SECRETARIA DA RECEITA FEDERAL (SRF)" },
                { "code": "SSP", "label": "SECRETARIA SEGURANCAPUBLICA (SSP)" },
                { "code": "TRT", "label": "TRIBUNAL REGIONAL DO TRABALHO (TRT)" }
            ],
            reEnviarSimulacaoResponse: null,
        }
    },
    mounted() {
        this.axiosErrorHandler();
    },
    methods: {
        axiosErrorHandler: function() {
            axios.interceptors.response.use(function(response) {
                return response;
            }, function(error) {
                if (!error.status) {
                    swal({
                        title: ":(",
                        text: "Serviço indisponível ou sem conexão com a internet.",
                        timer: 2000,
                    });
                    return Promise.reject(error);
                }
                return error;
            })
        },

        sleep: function(ms) {
            return new Promise((resolve) => setTimeout(resolve, ms));
        },

        simulacaoReenviada: function(r) {
            this.reEnviarSimulacaoResponse = r;
        },

        reEnviarSimulacao: async function() {
            this.reEnviarSimulacaoResponse = null;
            this.$emit("re-enviar-simulacao", "J");
            let timeout = 0;
            while (this.reEnviarSimulacaoResponse == null && timeout < 60) {
                await this.sleep(1000);
                timeout++;
            }
            return this.reEnviarSimulacaoResponse;
        },

        async reCallOnError(data, self, func, par1 = null, par2 = null, par3 = null) {
            if (
                data.error != null &&
                data.error.code == 500 &&
                data.error.message ==
                systemUnavailableMessage
            ) {
                await self.reEnviarSimulacao();
                if (par1 != null && par2 != null && par3 != null) {
                    return await func(par1, par2, par3);
                } else if (par1 != null && par2 != null) {
                    return await func(par1, par2);
                } else if (par1 != null) {
                    return await func(par1);
                } else {
                    return await func();
                }
            }

            if (data.error != null && data.error.code == 401) {
                await self.reEnviarSimulacao();
                if (par1 != null && par2 != null) {
                    return await func(par1, par2);
                } else if (par1 != null) {
                    return await func(par1);
                } else {
                    return await func();
                }
            }
            return false;
        },

        async getCertifiedAgents() {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetCertifiedAgents", {
                        token: self.token,
                        codigoPedido: self.codigoPedido.split("-")[0],
                        storeId: self.tabId,
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getCertifiedAgents
                    );
                    if (r) return r;

                    let certifiedAgents = response.data.result;
                    let options = [];
                    certifiedAgents.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getEstados() {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetEstados", {
                        token: self.token,
                        codigoPedido: self.codigoPedido.split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getEstados
                    );
                    if (r) return r;

                    let estados = response.data.result;
                    let options = [];
                    estados.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getProfissoes() {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetProfissoes", {
                        token: self.token,
                        codigoPedido: self.codigoPedido.split("-")[0] * 1,
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getProfissoes
                    );
                    if (r) return r;

                    let profissoes = response.data.result;
                    let options = [];
                    profissoes.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getGeneros() {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetGenero", {
                        token: self.token,
                        codigoPedido: self.codigoPedido.split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getGeneros
                    );
                    if (r) return r;
                    let generos = response.data.result;
                    let options = [];
                    generos.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getEstadosCivis() {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetEstadoCivil", {
                        token: self.token,
                        codigoPedido: self.codigoPedido.split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getEstadosCivis
                    );
                    if (r) return r;

                    let estadosCivis = response.data.result;
                    let options = [];
                    estadosCivis.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getTipoDocumento() {
            const self = this;
            return await axios
                .post(self.$apiUrl + "Santander.svc/GetTipoDocumento", {
                    token: self.token,
                    codigoPedido: self.codigoPedido.split("-")[0],
                })
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getTipoDocumento
                    );
                    if (r) return r;

                    let tipos = response.data.result;
                    let options = [];
                    tipos.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getNacionalidades() {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetNacionalidade", {
                        token: self.token,
                        codigoPedido: self.codigoPedido.split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getNacionalidades
                    );
                    if (r) return r;

                    let nacionalidades = response.data.result;
                    let options = [];
                    nacionalidades.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getNaturezasJuridicas() {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetNaturezasJuridicas", {
                        token: self.token,
                        codigoPedido: self.codigoPedido.split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getNaturezasJuridicas
                    );
                    if (r) return r;

                    let naturezas = response.data.result;
                    let options = [];
                    naturezas.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getTipoRelacionamentoEmpresa() {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetRelacionamentoEmpresa", {
                        token: self.token,
                        codigoPedido: self.codigoPedido.split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getTipoRelacionamentoEmpresa
                    );
                    if (r) return r;

                    let tipos = response.data.result;
                    let options = [];
                    tipos.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getGruposAtividade() {
            const self = this;
            return await axios
                .post(
                    this.$apiUrl + "Santander.svc/GetGrupos", {
                        token: this.token,
                        codigoPedido: this.codigoPedido.split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await this.reCallOnError(
                        response.data,
                        self,
                        this.getGruposAtividade
                    );
                    if (r) return r;

                    let grupos = response.data.result;
                    let options = [];
                    grupos.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getCidadeId(uf, cidadeProcurar) {
            let cidades = await this.GetCidadesPorEstado(uf);
            let cidade = cidades.filter((c) =>
                c.label.includes(
                    cidadeProcurar
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")
                    .toUpperCase()
                )
            );
            if (cidade.length > 0) return cidade[0].code;
            return null;
        },

        async getAtividadesEconomica(grupo) {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetAtividadesPorGrupo", {
                        idGrupo: grupo,
                        token: self.token,
                        codigoPedido: self.codigoPedido.split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getAtividadesEconomica,
                        grupo
                    );
                    if (r) return r;

                    let atividades = response.data.result;
                    let options = [];
                    atividades.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async GetCidadesPorEstado(uf) {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetCidadesPorEstado", {
                        idUf: uf,
                        token: self.token,
                        codigoPedido: self.codigoPedido.split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await self.reCallOnError(
                        response.data,
                        self,
                        self.getCidades,
                        uf
                    );
                    if (r) return r;

                    let cidades = response.data.result;
                    let options = [];
                    cidades.forEach((element) => {
                        let item = {};
                        item.code = element.id;
                        item.label = element.description;
                        options.push(item);
                    });
                    return options;
                });
        },

        async getCepInfo(cep) {
            const self = this;
            return await axios
                .post(
                    self.$apiUrl + "Santander.svc/GetAddressByZipCode", {
                        token: self.token,
                        zipCode: cep,
                        codigoPedido: self.codigoPedido.split("-")[0],
                    }, { withCredentials: true }
                )
                .then(async(response) => {
                    let r = await this.reCallOnError(
                        response.data,
                        self,
                        this.getCepInfos,
                        cep
                    );
                    if (r) return r;

                    if (response.data.error != null) {
                        swal({
                            title: "Aviso",
                            text: "Insira um CEP válido",
                            icon: "warning",
                        });
                        return false;
                    }
                    let cep = response.data.result;
                    return cep;
                });
        },

        async processaRespostaPropostaFisico(response, self) {
            return await self.processaRespostaProposta(response, self);
        },

        async processaRespostaPropostaJuridico(response, self) {
            return await self.processaRespostaProposta(response, self);
        },

        async processaRespostaProposta(response, self) {
            let error = response.data.error;
            if (
                error != null &&
                error.code == 400 &&
                error.message.includes("E-mail")
            ) {
                swal({
                    title: "Aviso",
                    text: "É necessário ter um e-mail com @gmail, por gentileza corrigi-lo.",
                    icon: "warning",
                });

                self.formInfoEmpresa.disabledEmail = false;

            } else if (error != null && error.code == 400) {
                swal({
                    title: "Aviso",
                    text: error.message,
                    icon: "warning",
                });

            } else if (error != null && error.code == 500) {
                let span = document.createElement("span");
                span.innerHTML = error.message;

                swal({
                    title: "Aviso",
                    content: span,
                    icon: "error",
                });

            } else {
                let proposta = response.data.result;
                if (proposta.proposalId != null && proposta.proposalId != 0) {
                    let negada = proposta.statusDescription
                        .toUpperCase()
                        .includes("NEGADA");
                    swal({
                        title: negada ?
                            "A proposta foi recusada" : "Proposta enviada com sucesso!",
                        text: negada ?
                            "Sua proposta foi negada pelo financiamento Santander, por favor tente com opções diferentes." : "O estado da proposta é:" +
                            proposta.statusDescription +
                            ".",
                        icon: negada ? "warning" : "success",
                    });
                    return proposta;
                } else {
                    swal({
                        title: "A proposta foi recusada!",
                        text: "Sua proposta foi negada pelo financiamento Santander, por favor tente com opções diferentes.",
                        icon: "error",
                    });
                }
            }
            return null;
        },
    }
}

export default SantanderPropostaMixing;